module.exports = __webpack_public_path__ + "05_short_brown.6c66b578.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/05_short_brown.png
// module id = YCI0
// module chunks = 0